module.exports = __webpack_public_path__ + "static/img/n-instructions.96dc6cc7.png";